import InputSuggestion from "components/app/function/InputSuggestion";
import { Button } from "components/ui/button";
import { Card } from "components/ui/card";
import React, { useEffect, useState } from "react";

const TodoPage: React.FC = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-6 space-y-2">
        <h1 className="text-2xl font-bold text-center mb-4">Zustand Todo App</h1>

        <InputSuggestion
          value={search}
          onChange={setSearch}
          placeholder="Search for jackie..."
          suggestions={["jackie", "jackie@aio.com", "jackie.lenkhen", "jackie shop"]}
          className="my-4"
          disabled={false}
        />

        <Button>Click</Button>
      </Card>
    </div>
  );
};

export default TodoPage;

